export default "__VITE_ASSET__CBpjHVTV__ 584w";